import { FileUp } from 'lucide-react';
import { Button } from '../../../../design-system/button/button';
import { Stack } from '../../../../design-system/stack/stack';
import { cn } from '../../../../utils/cn';
import { ViewProps } from './file-drop-zone';

const ICON_STROKE_WIDTH = 0.5;

export const FileDropZoneStackedView = ({ isLoading, fileRejection, open, setFileRejection }: ViewProps) => {
  return (
    <Stack space={3} align="center">
      <div className="h-12 w-12">
        <FileUp
          strokeWidth={ICON_STROKE_WIDTH}
          className={cn('h-full w-full font-light text-black', { 'text-black/40': isLoading })}
        />
      </div>

      <Stack align="center">
        <p className={cn('text-sm font-normal text-black', { 'text-black/40': isLoading })}>
          Drop an invoice here or click to upload
        </p>

        <p
          className={cn('text-xs font-normal text-seapoint-gray-text', {
            'text-seapoint-gray-text/40': isLoading,
          })}
        >
          We currently support PDF files only.
        </p>

        {fileRejection && <p className="text-xs font-medium text-seapoint-red">{fileRejection}</p>}
      </Stack>

      <Button
        size="default"
        onClick={() => {
          setFileRejection(null);

          open();
        }}
        isLoading={isLoading}
      >
        Browse
      </Button>
    </Stack>
  );
};
